import { rest } from 'msw';
import { delay } from '../config';

export const createUser = [
  rest.post('/api/user/create', (req, res, ctx) => {
    return res(delay(), ctx.status(200));
  }),
];
